<template>
  <v-snackbar
    v-model="$common.snackBar"
    :multi-line="mutliline"
    :color="color"
    :top="top"
    :timeout="timeout"
    v-if="payload.status"
  >
    <strong class="text-center Subtitle 2 font-weight-black">
      {{ payload.status + ' - ' + payload.message }}
    </strong>
    <template v-slot:action="{ attrs }">
      <v-btn @click="$common.snackBar = false" v-bind="attrs" v-if="hasAction" icon>
        <v-icon color="#fff">mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'StatusPopup',
  props: ['type', 'payload', 'color', 'top', 'timeout', 'hasAction', 'mutliline']
};
</script>
